import { ReactNode } from 'react';
import { CaretRightNextIcon, CaretLeftNextIcon } from '@glu/icons-react';
import { Typography } from '@glu/typography-react';
import locale from '@glu/locale';
import { Button, TERTIARY, SMALL } from '@glu/buttons-react';
import useStyles from './PageSelector.styles';
import { IPaginationProps } from '../Pagination/Pagination';

export interface IPageSelectorProps {
  children: ReactNode;
  /** The last page to display */
  last: number;
  onNextPage: IPaginationProps['onNextPage'];
  onPreviousPage: IPaginationProps['onPreviousPage'];
  page: IPaginationProps['page'];
}

export default function PageSelector({
  children,
  last,
  onNextPage,
  onPreviousPage,
  page,
}: IPageSelectorProps) {
  const classes = useStyles();

  return (
    <div className={classes.selectorWrapper}>
      {page > 0 && (
        <Button
          className={classes.previous}
          data-qa="pagination-rightArrow"
          onClick={onPreviousPage}
          size={SMALL}
          variant={TERTIARY}
        >
          <Typography variant="accessibility">{locale.get('dataComponents.previous')}</Typography>
          <CaretRightNextIcon />
        </Button>
      )}
      <div className={classes.flexWrapper}>{children}</div>
      {page < last && (
        <Button
          className={classes.next}
          data-qa="pagination-leftArrow"
          onClick={onNextPage}
          size={SMALL}
          variant={TERTIARY}
        >
          <Typography variant="accessibility">{locale.get('dataComponents.next')}</Typography>
          <CaretLeftNextIcon />
        </Button>
      )}
    </div>
  );
}
